import {EPdfDownloadStatus, IMyOrderState} from '@app/order/models/my-order-state.model';
import {createReducer, on} from '@ngrx/store';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';
import {
  downloadOrderResultsSuccess,
  getEditOrderDetailsFailure,
  getEditOrderDetailsSuccess,
  getOrderResultsPdfDetailsSuccess,
  loadListOfOrders,
  loadListOfOrdersFailure,
  loadListOfOrdersSuccess,
  loadOrderStatus,
  loadOrderStatusFailure,
  loadOrderStatusSuccess,
  resetDownloadOrderResultsStatus,
  resetEditOrderDetails,
  resetOrderResultsPdfDetails,
} from './my-order.actions';

const initialMyOrderState: IMyOrderState = {
  myOrderDetailsStatus: EActionStatus.Initial,
  myOrderDetailsResponse: '',
  myOrderDetails: null,
  OrderStatus: EActionStatus.Initial,
  orderStatusResponse: '',
  listOfOrderStatus: null,
  editOrderDetails: null,
  editOrderStatus: EActionStatus.Initial,
  orderResultsPdfDetails: null,
  downloadOrderResultsStatus: null,
};

export const myOrderReducer = createReducer(
  initialMyOrderState,
  on(loadListOfOrders, state => ({
    ...state,
    myOrderDetailsStatus: EActionStatus.Pending,
  })),
  on(loadListOfOrdersSuccess, (state, {orders}) => ({
    ...state,
    myOrderDetailsStatus: EActionStatus.Success,
    myOrderDetails: orders,
  })),
  on(loadListOfOrdersFailure, (state, {reason}) => ({
    ...state,
    myOrderDetailsStatus: EActionStatus.Failure,
    myOrderDetailsResponse: reason,
  })),
  on(loadOrderStatus, state => ({
    ...state,
    OrderStatus: EActionStatus.Pending,
  })),
  on(loadOrderStatusSuccess, (state, {orderStatus}) => ({
    ...state,
    OrderStatus: EActionStatus.Success,
    listOfOrderStatus: orderStatus,
  })),
  on(loadOrderStatusFailure, (state, {reason}) => ({
    ...state,
    OrderStatus: EActionStatus.Failure,
    orderStatusResponse: reason,
  })),
  on(getEditOrderDetailsSuccess, (state, {editOrderInfo}) => ({
    ...state,
    editOrderDetails: editOrderInfo,
    editOrderStatus: EActionStatus.Success,
  })),
  on(resetEditOrderDetails, state => ({
    ...state,
    editOrderDetails: null,
    editOrderStatus: EActionStatus.Initial,
  })),
  on(getEditOrderDetailsFailure, state => ({
    ...state,
    editOrderDetails: null,
    editOrderStatus: EActionStatus.Failure,
  })),
  on(getOrderResultsPdfDetailsSuccess, (state, {resultsInfo}) => ({
    ...state,
    orderResultsPdfDetails: resultsInfo,
  })),
  on(resetOrderResultsPdfDetails, state => ({
    ...state,
    orderResultsPdfDetails: null,
  })),
  on(downloadOrderResultsSuccess, (state, {downloadStatus}) => ({
    ...state,
    downloadOrderResultsStatus: downloadStatus,
  })),
  on(resetDownloadOrderResultsStatus, state => ({
    ...state,
    downloadOrderResultsStatus: EPdfDownloadStatus.Initial,
  }))
);
